import { Context } from '@/models/order-history/status/context/context'
import { ReorderAcceptabilityState } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state'

export abstract class CreateStateCommand<T extends Context> {
  execute(context: T): ReorderAcceptabilityState {
    if (!this.shouldApply(context)) {
      throw new Error(`This command cannot be executed.`)
    }

    return this.createState(context)
  }
  abstract shouldApply(context: Context): context is T
  protected abstract createState(context: T): ReorderAcceptabilityState
}
